import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "是否異常",
    isNumber: true,
  },
];

export const BarConsult = {
  label: "諮詢狀況(2025年)",
  key: "BarConsult",
  path: "HealthAnalysisManagement/BarConsult",
  api: "TCS_V_EyesS01",
  render: (options) => (
    <Diagram.HealthAnalysisManagement.BarConsult {...options} />
  ),
  xKey: "type",
  barUnit: "人",
  barColumns: [
    {
      key: "aa",
      label: "營養師諮詢",
      ui: "bar",
    },
    {
      key: "bb",
      label: "護理(醫)師諮詢",
      ui: "bar",
    },
  ],
  columns: [],
};
